import { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { setTrackingNumber } from '../services/adminWorkspaceService';

const { FiCheck, FiCopy, FiLink, FiMessageCircle, FiSave } = FiIcons;

export function buildTrackingUrl(token) {
  return `${window.location.origin}/track/${token}`;
}

async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
  } catch {
    const area = document.createElement('textarea');
    area.value = text;
    document.body.appendChild(area);
    area.select();
    document.execCommand('copy');
    document.body.removeChild(area);
  }
}

function OrderShareTools({ order, whatsapp, onMessage, onSaved }) {
  const [tracking, setTracking] = useState(order.tracking_number || '');
  const [saving, setSaving] = useState(false);
  const [copied, setCopied] = useState(false);

  if (!order.tracking_ready || !order.share_token) {
    return (
      <div className="order-share-box muted">
        <SafeIcon icon={FiLink} />
        <span>
          Live tracking links need database migration 202609250018.
        </span>
      </div>
    );
  }

  const url = buildTrackingUrl(order.share_token);
  const whatsappText = encodeURIComponent(
    `Hi ${order.customer_name}, thank you for your ZEVI order ${order.order_number}. ` +
    `You can follow its live status here: ${url}`
  );

  const copyLink = async () => {
    await copyText(url);
    setCopied(true);
    onMessage(`Tracking link for ${order.order_number} copied.`);
    setTimeout(() => setCopied(false), 2000);
  };

  const saveTracking = async () => {
    setSaving(true);
    try {
      await setTrackingNumber(order.id, tracking);
      onSaved(`Tracking number saved for ${order.order_number}.`);
    } catch (error) {
      onMessage(error.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="order-share-box">
      <div className="order-share-head">
        <SafeIcon icon={FiLink} />
        <strong>Customer tracking link</strong>
      </div>

      <div className="order-share-row">
        <input
          readOnly
          value={url}
          aria-label="Customer tracking link"
          onFocus={(event) => event.target.select()}
        />
        <button
          type="button"
          className={`order-share-btn ${copied ? 'copied' : ''}`}
          onClick={copyLink}
        >
          <SafeIcon icon={copied ? FiCheck : FiCopy} />
          {copied ? 'Copied' : 'Copy link'}
        </button>
      </div>

      <div className="order-share-row">
        <input
          value={tracking}
          maxLength={80}
          placeholder="Tracking number (optional)"
          aria-label="Tracking number"
          onChange={(event) => setTracking(event.target.value)}
        />
        <button
          type="button"
          className="order-share-btn"
          onClick={saveTracking}
          disabled={saving || tracking.trim() === (order.tracking_number || '')}
        >
          <SafeIcon icon={FiSave} />
          {saving ? 'Saving…' : 'Save'}
        </button>
      </div>

      {whatsapp && (
        <a
          className="order-share-whatsapp"
          href={`https://wa.me/${whatsapp}?text=${whatsappText}`}
          target="_blank"
          rel="noreferrer"
        >
          <SafeIcon icon={FiMessageCircle} />
          Send link to customer on WhatsApp
        </a>
      )}
    </div>
  );
}

export default OrderShareTools;